import React, { Fragment } from 'react';

import clsx from 'clsx';
import { useProductState } from '../store';
import { first, sortBy } from 'lodash';

import { useTranslation } from 'react-i18next';

import usePrice from '@/hooks/usePrice';
import { useGiftProduct } from '@/hooks/products/use-gift-product';

const Price = () => {
  const { t } = useTranslation();
  const [formatPrice] = usePrice();
  const { product, variation } = useProductState();

  const gift = useGiftProduct(product.selling_code);

  const firstLowestVariationPrice = first(
    sortBy(product.variations, ({ price }) => {
      return Math.min(
        Number.parseFloat(price.sale_price ? price.sale_price : price.price),
        Number.parseFloat(price.price)
      );
    })
  )?.price;

  const price = variation?.price || firstLowestVariationPrice;

  return (
    <div>
      {gift ? (
        <span className="font-bold">{t('PRODUCT_FREE')}</span>
      ) : (
        <Fragment>
          <span
            className={clsx({
              'line-through text-gray-500': price?.sale_price
            })}
          >
            {formatPrice(price?.price)}
          </span>

          {price?.sale_price && (
            <span className="font-bold">{formatPrice(price.sale_price)}</span>
          )}
        </Fragment>
      )}
    </div>
  );
};

export default Price;
